import { mainWeb } from '../../../config/net'
const index = `${mainWeb}/OrderInfo/Ajax/action.ashx?type=chargepricelist`
const checkPhone = `${mainWeb}/OrderInfo/Ajax/action.ashx?type=GetPhoneCheck`
const checkPhoneData = `${mainWeb}/OrderInfo/Ajax/action.ashx?type=GetPhoneDataCheck`

export default {
  index,
  checkPhone,
  checkPhoneData
}



// WEBPACK FOOTER //
// ./src/model/rechage/phone/resource-url.js